import axios, { AxiosError, AxiosResponse } from "axios";
import { IApiResponse } from "src/shared/models/IApiResponse";
import {
  alertFromAPIResponse,
  AlertPosition,
} from "src/shared/services/AlertService";

const axiosApiInstanceNoToken = axios.create();
axiosApiInstanceNoToken.defaults.baseURL = process.env.REACT_APP_RETAIL_API_URL;

axiosApiInstanceNoToken.interceptors.response.use(
  response => {
    const { data } = response || {};
    alertFromAPIResponse(data, AlertPosition.topCenter);
    return response;
  },
  async function (error) {
    const axioError = error as AxiosError;
    const { data } = (axioError.response as AxiosResponse<IApiResponse>) || {};
    alertFromAPIResponse(data, AlertPosition.topCenter);
    if (axioError.response?.status === 401) {
      // alert("No Autorizado");
    }
    return Promise.reject(error);
  }
);

export default axiosApiInstanceNoToken;
